import Box from "@mui/material/Box";
import "./App.scss";
import SideMenu from "./components/template/base-template/side-menu/side-menu";
import Glossary from "./pages/career-map/glossary";
import React, { useState, useEffect, useRef } from "react";
import Workbench from "./pages/career-map/workbench";
import Loading from "./components/template/base-template/load-map";

import { useSelector } from "react-redux";
import { stateRelatedRoles } from "./store/ducks/relatedRoles";
import FilterMenu from "./components/template/base-template/filter/filter";
import { BoxProps, styled } from "@mui/material";
import { widthAndHeigth } from "./utils/screenValidations/screen";

const BoxFilterMenu = styled((props: BoxProps) => <Box {...props} />)(({ theme }) => ({
    zIndex: 1,
    marginLeft: 100,
    transition: "width 0.3s linear",
    width: "auto",
    position: "absolute",
    "@media (min-width: 300px) and (max-width: 600px)": {
        marginLeft: "0px",
    },
}));

function App() {
    const [selectedMenu, setSelectedMenu] = useState({
        showMap: true,
        showGlossary: false,
    });
    const widthScreen = useRef<any>(widthAndHeigth().width).current;
    const heightScreen = useRef<any>(widthAndHeigth().height).current;
    const { relatedRole, filterRole } = useSelector(stateRelatedRoles);
    const handleToggle = (value: { showMap: boolean; showGlossary: boolean }) => {
        setSelectedMenu(value);
    };

    useEffect(() => {
        if (selectedMenu.showMap) {
            document.body.style.overflow = "hidden";
        }
    }, [selectedMenu.showMap, selectedMenu.showGlossary]);
    useEffect(() => {
        if (filterRole) {
            handleToggle({
                showGlossary: false,
                showMap: true,
            });
        }
    }, [filterRole]);

    return (
        <Box width={widthScreen} overflow={selectedMenu.showMap ? "hidden" : "auto"} height={heightScreen} display={"flex"}>
            <SideMenu
                values={{
                    showMap: selectedMenu.showMap,
                    showGlossary: selectedMenu.showGlossary,
                }}
                onToggle={handleToggle}
            />

            {!selectedMenu.showGlossary && (
                <BoxFilterMenu>
                    <FilterMenu />
                </BoxFilterMenu>
            )}
            {relatedRole?.nodes.length === 0 && <Loading />}

            {selectedMenu.showMap && <Workbench />}
            {selectedMenu.showGlossary ? <Glossary /> : null}
        </Box>
    );
}

export default App;
